import {useEffect, useState, useCallback} from "react";
import { ProgressBar} from "react-bootstrap";
import SimpleBackdrop from "./background";
import Skeleton from '@mui/material/Skeleton';
import {getImageUrl, trimText} from "../globalMethods/utils";
import Box from '@mui/material/Box';
import {useMediaQuery, useTheme} from "@mui/material";

const LiveShowDetails = (props) =>{
    const [showEvent, setShowEvent] = useState({})
    const [showEvents] = useState(props?.showEvents)
    const [nowTime, setNowTime] = useState(0)
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    const getLiveShowsDetails = useCallback(() => { // Use useCallback if it depends on props or state
        if(showEvents?.length > 0){
            setShowEvent(showEvents[0])
        }
        const actualTime = new Date().getTime()
        if(showEvents?.length > 0){
            for (let showsEventL of showEvents){
                let duration =  showsEventL?.timecodes[0]?.duration
                let eventStartDate =  new Date(showsEventL?.startDate)
                let endingDate = eventStartDate.getTime() + duration
                let startingDate = eventStartDate.getTime()
                let nowPercentage = ((duration - (endingDate - actualTime) ) / duration).toFixed(2)
                let nowPercentageDecimal = (parseFloat(nowPercentage) * 100 ).toFixed(0)
                setNowTime(parseInt(nowPercentageDecimal))
                if((startingDate < actualTime) && (endingDate > actualTime)){
                    setShowEvent(showsEventL)
                    break
                }
            }
        }
    }, [showEvents, setNowTime, setShowEvent]); // Add any dependencies of getLiveShowsDetails

    useEffect(() => {
        getLiveShowsDetails()
        const interval = setInterval(() => {
            getLiveShowsDetails()
        }, 1000);
        return () => clearInterval(interval);
    }, [getLiveShowsDetails]); // Include getLiveShowsDetails in the dependency array

    // ... rest of your component


    const handleClickOpen = () => {
        window.location.href = "/liveVideo/" + props?.EpgId ;
    };



    return <>
        {
            showEvent === {} ? <>
                    <SimpleBackdrop open={true}></SimpleBackdrop>

                </>
                : <>
                    <Box
                        onClick={handleClickOpen}
                        className={"custom-item"}
                        title={showEvent?.title}
                        sx={{ textDecoration:"none",position:"relative",  marginTop:10, display:"block"}} >
                        {
                            showEvent?.picture ? (
                                <picture>
                                    {/* Mobile: up to 419px (170x95) */}
                                    <source
                                        srcSet={`${getImageUrl(showEvent.picture, { width: 170, height: 95 })}, ${getImageUrl(showEvent.picture, { width: 170, height: 95 }, 2)} 2x`}
                                        media="(max-width: 419px)"
                                    />

                                    {/* Tablet/Small Desktop: 420px to 769px (approx 332x186 and 229x128) */}
                                    {/* Combining original 699px and 769px media queries for simplicity */}
                                    <source
                                        srcSet={`${getImageUrl(showEvent.picture, { width: 332, height: 186 })}, ${getImageUrl(showEvent.picture, { width: 332, height: 186 }, 2)} 2x`}
                                        media="(max-width: 769px)"
                                    />

                                    {/* Large Desktop/Default (Over 769px) */}
                                    <source
                                        srcSet={`${getImageUrl(showEvent.picture, { width: 256, height: 143 })}, ${getImageUrl(showEvent.picture, { width: 256, height: 143 }, 2)} 2x`}
                                        media="(max-width: 1440px)"
                                    />

                                    {/* Fallback/Default Image for all other sizes and browsers that don't support <picture> */}
                                    <img
                                        style={{maxWidth:isDesktop? 458 : 200, minWidth:isDesktop? 458 : 200}}
                                        loading="lazy"
                                        src={getImageUrl(showEvent.picture, { width: 458, height: 256 })} // Using one of the larger sizes as a robust default
                                        alt={showEvent?.subTitle || ''}
                                    />
                                </picture>

                            ) : (
                                <Skeleton variant="rectangular" width={458} height={256}/>
                            )

                        }
                        {
                            nowTime !== 0 ? <ProgressBar style={{marginTop: 5, opacity: 0.60, minWidth:isDesktop? 458: 250, maxWidth:isDesktop? 458:250}} animated now={nowTime}></ProgressBar>
                                :<></>
                        }
                       <div style={{ marginTop:-85}} className="cardLogoChannel">
                             <img loading={"lazy"} alt={props?.Name} src={props?.LogoUrl}/>
                        </div>
                        <div style={{fontFamily:"Orbitron", marginTop:10 }}>
                            <p  style={{fontWeight:"bold", fontSize: isDesktop? 18 : 12,marginTop:2, textAlign:"start"}}>{trimText(showEvent?.title, 30)}</p>
                            <p  style={{fontWeight:"bold", fontSize: isDesktop? 23 : 15, marginTop: -5, textAlign:"start"}}>{trimText(showEvent?.subTitle, 30)} </p>
                        </div>
                    </Box>
                </>


        }
    </>
}

export default LiveShowDetails;
